import React from "react";
// Components
import { Field } from "components";
import { BaseInput } from "components/Common/Field/BaseInput";

export const InputNumber: React.FC<InputNumberProps> = ({ step, ...props }) => (
  <BaseInput {...props} step={step || "any"} type="number" />
);
InputNumber.displayName = "InputNumber";

export const FieldNumber: React.FC<FieldNumberProps> = ({ error, inputProps, ...props }) => (
  <Field error={error} labelFor={inputProps.name} {...props}>
    <InputNumber hasError={!!error} {...inputProps} />
  </Field>
);
FieldNumber.displayName = "FieldNumber";
